export default {
    position: {
        backToDashboard: 'Nazaj na nadzorno ploščo',
        loadError: 'Pozicije za pogodbo ni bilo mogoče naložiti',
        tryAgain: 'Poskusite znova',
        header: 'Prikaz pozicije — {name} · {country} · {side} · {product}',
        deliveryLine: 'Dobava: {start} → {end} · {mwh} prispeva ta pogodba',
        mergeMeta: 'Zadnja združitev: {lastRun} · {days} dni · {buckets} intervalov',
        noSnapshotTitle: 'Posnetka pozicije še ni',
        noSnapshotBody:
            'Združitev za {start}–{end} še ni bila sprožena. Po združitvi se bo prispevek te pogodbe pojavil tukaj.',
        prevDayAria: 'Prejšnji dan (Alt+←)',
        nextDayAria: 'Naslednji dan (Alt+→)',
        show: 'Prikaži:',
        forecastBaseline: 'Osnovna napoved',
        thisContract: 'Ta pogodba',
        allFutures: 'Vsi terminski posli',
        zeroContribution:
            'Ta pogodba nima dobave na dan {day} (izven obdobja dobave ali ničelna dodelitev).',
        footerSummary:
            'Ta dan · napoved {forecast} MWh · terminski {futures} MWh · končno {final} MWh · smer {direction}',
    },
}
